import { Children } from "react";
import { Route } from "../Router";
/**
 * @param reactRoute
 * @return {Route}
 */
export function convertReactComponentRoutesToStandardRoutes(reactRoute) {
    let routeOpts = {
        name: reactRoute.props.name,
        path: reactRoute.props.path,
        callback: () => reactRoute.props.component,
        middleware: reactRoute.props.middleware,
        children: [],
    };
    Children.forEach(reactRoute.props.children, (child) => {
        routeOpts.children.push(convertReactComponentRoutesToStandardRoutes(child));
    });
    return new Route(routeOpts);
}
